module.exports = __webpack_public_path__ + "static/media/Leboncoin.fr_Logo_2016.svg.6177645d.png";